import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export const UnavailableEMSNsAlert = () => {
  const { t } = useTranslation('eMSNPage')
  return (
    <Alert variation='warn' hideIcon>
      {t('emsn-results.emsns-are-unavailable')}
    </Alert>
  )
}
